// import React, { useEffect, useState, useRef, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ConfigContext } from '../../Context/ConfigContext';
// import axios from 'axios';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const idleTimeout = useRef(null);
//     const [isIdle, setIsIdle] = useState(false);
//     const navigate = useNavigate();

//     useEffect(() => {
//         // Reset idle timer on user activity
//         const resetTimer = () => {
//             clearTimeout(idleTimeout.current);
//             setIsIdle(false);
//             idleTimeout.current = setTimeout(() => {
//                 setIsIdle(true);
//             }, 15 * 60 * 1000); // 15 minutes timeout
//         };

//         // Add event listeners for user activity
//         const events = ['mousemove', 'keydown', 'click'];
//         events.forEach(event => window.addEventListener(event, resetTimer));

//         // Add visibility change listener (for tab switching)
//         const handleVisibilityChange = () => {
//             if (document.hidden) {
//                 // Consider as inactive when tab is not visible
//                 resetTimer();
//             }
//         };
//         document.addEventListener('visibilitychange', handleVisibilityChange);

//         // Cleanup listeners on component unmount
//         return () => {
//             clearTimeout(idleTimeout.current);
//             events.forEach(event => window.removeEventListener(event, resetTimer));
//             document.removeEventListener('visibilitychange', handleVisibilityChange);
//         };
//     }, []);
//     const getRegularizationSettings = () => {
//         const headers = apiHeaderJSON;
//         axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers }).then((response) => {
//             const { data, success, message } = response.data;
//             if (success === false && message === "This token has been expired.") {
//                 setIsIdle(true);
//             }
//         });
//     }
//     const handleLogout = () => {
//         localStorage.removeItem("token_emp");
//         localStorage.removeItem("company_id_emp");
//         localStorage.removeItem("employee_id_emp");
//         localStorage.removeItem("employee_code_emp");
//         navigate("/Login");
//         window.location.reload();
//     };

//     useEffect(() => {
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     useEffect(() => {
//         getRegularizationSettings();
//     }, [])

//     return null;
// };

// export default AutoLogout;

// import React, { useState, useContext, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
// import { ConfigContext } from '../../Context/ConfigContext';
// import axios from 'axios';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const [isIdle, setIsIdle] = useState(false);
//     const navigate = useNavigate();

//     const handleOnIdle = () => {
//         console.log('User is idle, logging out.');
//         setIsIdle(true);
//     };

//     const handleOnActive = () => {
//         console.log('User is active again.');
//         setIsIdle(false);
//     };

//     const handleLogout = () => {
//         console.log('Logging out due to inactivity.');
//         localStorage.removeItem("token_emp");
//         localStorage.removeItem("company_id_emp");
//         localStorage.removeItem("employee_id_emp");
//         localStorage.removeItem("employee_code_emp");
//         navigate("/Login");
//         window.location.reload();
//     };

//     const getRegularizationSettings = () => {
//         const headers = apiHeaderJSON;
//         axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
//             .then(response => {
//                 const { success, message } = response.data;
//                 if (success === false && message === "This token has been expired.") {
//                     console.log('Token has expired, triggering idle state.');
//                     setIsIdle(true); // Treat expired token as idle
//                 }
//             })
//             .catch(error => {
//                 console.error('Error fetching regularization settings:', error);
//             });
//     };

//     useEffect(() => {
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     useEffect(() => {
//         getRegularizationSettings();
//     }, []);

//     return (
//         <IdleTimerProvider
//             timeout={15 * 60 * 1000} // 15 minutes
//             onIdle={handleOnIdle}
//             onActive={handleOnActive}
//             debounce={500}
//         >
//             {null}
//         </IdleTimerProvider>
//     );
// };

// export default AutoLogout;

// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
// import { ConfigContext } from '../../Context/ConfigContext';
// import axios from 'axios';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const [isIdle, setIsIdle] = useState(false);
//     const [lastActive_emp, setLastActive_emp] = useState(Date.now());
//     const navigate = useNavigate();
//     const idleTimeout = 15 * 60 * 1000; // 15 minutes

//     // Synchronize the last active time across tabs using localStorage
//     const syncLastActive = () => {
//         const storedLastActive = localStorage.getItem('lastActive');
//         if (storedLastActive && parseInt(storedLastActive) !== lastActive) {
//             setLastActive(parseInt(storedLastActive));
//         }
//     };

//     useEffect(() => {
//         window.addEventListener('storage', syncLastActive); // Listen for changes in other tabs
//         return () => {
//             window.removeEventListener('storage', syncLastActive);
//         };
//     }, [lastActive]);

//     const handleOnIdle = () => {
//         console.log('User is idle, logging out.');
//         setIsIdle(true);
//     };

//     const handleOnActive = () => {
//         console.log('User is active, resetting timer.');
//         setLastActive(Date.now());
//         localStorage.setItem('lastActive', Date.now()); // Update localStorage with current activity
//         setIsIdle(false);
//     };

//     const handleLogout = () => {
//         console.log('Logging out due to inactivity.');
//         localStorage.removeItem('token');
//         localStorage.removeItem('company_id');
//         localStorage.removeItem('employee_id');
//         localStorage.removeItem('employee_code');
//         navigate('/Login');
//         window.location.reload();
//     };

//     const pollIdleState = () => {
//         const currentTime = Date.now();
//         const idleTime = currentTime - lastActive;
//         if (idleTime >= idleTimeout) {
//             handleOnIdle();
//         }
//     };

//     // Fallback polling every 1 minute to check idle state
//     useEffect(() => {
//         const interval = setInterval(pollIdleState, 60 * 1000);
//         return () => clearInterval(interval);
//     }, [lastActive]);

//     const getRegularizationSettings = () => {
//         const headers = apiHeaderJSON;
//         axios
//             .get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
//             .then(response => {
//                 const { success, message } = response.data;
//                 if (success === false && message === 'This token has been expired.') {
//                     console.log('Token has expired, triggering idle state.');
//                     setIsIdle(true); // Treat expired token as idle
//                 }
//             })
//             .catch(error => {
//                 console.error('Error fetching regularization settings:', error);
//             });
//     };

//     useEffect(() => {
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     useEffect(() => {
//         getRegularizationSettings();
//     }, []);

//     return (
//         <IdleTimerProvider
//             timeout={idleTimeout}
//             onIdle={handleOnIdle}
//             onActive={handleOnActive}
//             debounce={500}
//         >
//             {/* Idle timer is handled in the background, no UI elements */}
//             {null}
//         </IdleTimerProvider>
//     );
// };

// export default AutoLogout;

// =>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { IdleTimerProvider, useIdleTimer } from 'react-idle-timer';
// import { ConfigContext } from '../../Context/ConfigContext';
// import axios from 'axios';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const [isIdle, setIsIdle] = useState(false);
//     const [lastActive, setLastActive] = useState(Date.now());
//     const navigate = useNavigate();
//     const idleTimeout = 15 * 60 * 1000; // 15 minutes

//     // Function to reset idle timer and update last active timestamp
//     const resetIdleTimer = () => {
//         setLastActive(Date.now());
//         localStorage.setItem('lastActive', Date.now()); // Sync across tabs
//         setIsIdle(false); // Reset idle state
//     };

//     // Sync the last active time across tabs using localStorage
//     const syncLastActive = () => {
//         const storedLastActive = localStorage.getItem('lastActive');
//         if (storedLastActive && parseInt(storedLastActive) !== lastActive) {
//             setLastActive(parseInt(storedLastActive));
//         }
//     };

//     useEffect(() => {
//         window.addEventListener('storage', syncLastActive); // Listen for changes in other tabs
//         return () => {
//             window.removeEventListener('storage', syncLastActive);
//         };
//     }, [lastActive]);

//     // Handle when user becomes idle
//     const handleOnIdle = () => {
//         console.log('User is idle, logging out.');
//         setIsIdle(true);
//     };

//     // Handle when user becomes active
//     const handleOnActive = () => {
//         console.log('User is active, resetting timer.');
//         resetIdleTimer(); // Reset idle timer on user activity
//     };

//     const handleLogout = () => {
//         console.log('Logging out due to inactivity.');
//         localStorage.removeItem('token');
//         localStorage.removeItem('company_id');
//         localStorage.removeItem('employee_id');
//         localStorage.removeItem('employee_code');
//         navigate('/Login');
//         window.location.reload();
//     };

//     // Polling as a fallback for idle state detection
//     const pollIdleState = () => {
//         const currentTime = Date.now();
//         const idleTime = currentTime - lastActive;
//         if (idleTime >= idleTimeout) {
//             handleOnIdle();
//         }
//     };

//     // Fallback polling every minute to check idle state
//     useEffect(() => {
//         const interval = setInterval(pollIdleState, 60 * 1000);
//         return () => clearInterval(interval);
//     }, [lastActive]);

//     // Fetch regularization settings and handle token expiration
//     const getRegularizationSettings = () => {
//         const headers = apiHeaderJSON;
//         axios
//             .get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
//             .then(response => {
//                 const { success, message } = response.data;
//                 if (success === false && message === 'This token has been expired.') {
//                     console.log('Token has expired, triggering idle state.');
//                     setIsIdle(true); // Treat expired token as idle
//                 }
//             })
//             .catch(error => {
//                 console.error('Error fetching regularization settings:', error);
//             });
//     };

//     // Add manual event listeners for user activity
//     useEffect(() => {
//         const resetTimerOnActivity = () => resetIdleTimer();

//         const events = ['mousemove', 'keydown', 'click', 'touchstart', 'scroll']; // Common user actions
//         events.forEach(event => window.addEventListener(event, resetTimerOnActivity));

//         return () => {
//             events.forEach(event => window.removeEventListener(event, resetTimerOnActivity));
//         };
//     }, []);

//     useEffect(() => {
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     useEffect(() => {
//         getRegularizationSettings();
//     }, []);

//     return (
//         <IdleTimerProvider
//             timeout={idleTimeout}
//             onIdle={handleOnIdle}
//             onActive={handleOnActive}
//             debounce={500} // Prevent multiple rapid triggers
//         >
//             {/* Idle timer is handled in the background, no UI elements */}
//             {null}
//         </IdleTimerProvider>
//     );
// };

// export default AutoLogout;

import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { IdleTimerProvider } from 'react-idle-timer';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';

const AutoLogout = () => {
    const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
    const [isIdle, setIsIdle] = useState(false);
    const navigate = useNavigate();
    const idleTimeout = 15 * 60 * 1000; // 15 minutes

    // Logout function
    const handleLogout = () => {
        console.log('Logging out due to inactivity or browser close.');
        localStorage.removeItem('token_emp');
        localStorage.removeItem('company_id_emp');
        localStorage.removeItem('employee_id_emp');
        localStorage.removeItem('employee_code_emp');
        navigate('/');
        window.location.reload();
    };

    // Function to reset idle timer and update last active timestamp
    const resetIdleTimer = () => {
        localStorage.setItem('lastActive_emp', Date.now()); // Sync across tabs
        setIsIdle(false); // Reset idle state
    };

    // Sync the last active time across tabs using localStorage
    const syncLastActive_emp = () => {
        const storedLastActive_emp = localStorage.getItem('lastActive_emp');
        if (storedLastActive_emp) {
            resetIdleTimer(); // Reset idle state if activity is detected
        } else {
            console.warn('No lastActive_emp found. Skipping sync for fresh session.');
        }
    };
    useEffect(() => {
        // On fresh load, initialize lastActive_emp if missing
        const storedLastActive_emp = localStorage.getItem('lastActive_emp');
        if (!storedLastActive_emp) {
            localStorage.setItem('lastActive_emp', Date.now()); // Initialize
        }
    
        // Add event listener for cross-tab synchronization
        window.addEventListener('storage', syncLastActive_emp);
    
        return () => {
            window.removeEventListener('storage', syncLastActive_emp);
        };
    }, []);
    useEffect(() => {
        const token = localStorage.getItem('token_emp');
        if (!token) {
            setIsIdle(true); // Trigger idle if no token exists
            return;
        }
    
        const now = Date.now();
        const storedLastActive_emp = localStorage.getItem('lastActive_emp');
    
        // Prevent immediate logout on fresh load
        if (!storedLastActive_emp || now - storedLastActive_emp < idleTimeout) {
            console.log('Session is active, preventing immediate logout.');
            resetIdleTimer();
        } else {
            setIsIdle(true);
        }
    }, []);
    
    useEffect(() => {
    const sessionKey = 'session_active_emp';

    // Check and initialize session status
    if (!sessionStorage.getItem(sessionKey)) {
        sessionStorage.setItem(sessionKey, 'true'); // Set session as active
    }

    // Handle visibility changes for refresh scenarios
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            sessionStorage.setItem('refresh_flag_emp', 'true');
        } else {
            sessionStorage.removeItem('refresh_flag_emp');
        }
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
        window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
}, []);


    // useEffect(() => {
    //     const sessionKey = 'session_active_emp';
    //     const refreshFlagKey = 'refresh_flag_emp';
    //     const isSessionActive = sessionStorage.getItem(sessionKey);

    //     // If no active session found (i.e., browser was closed, not just refreshed), log out
    //     console.log(`!isSessionActive && !sessionStorage.getItem(refreshFlagKey)`,isSessionActive && sessionStorage.getItem(refreshFlagKey))
    //     if (!isSessionActive && !sessionStorage.getItem(refreshFlagKey)) {
    //         handleLogout();
    //     }

    //     // Set session as active on page load
    //     sessionStorage.setItem(sessionKey, 'true');

    //     // Handle visibility change to detect refresh
    //     const handleVisibilityChange = () => {
    //         if (document.visibilityState === 'hidden') {
    //             // Page is being hidden (may indicate a close or refresh)
    //             sessionStorage.setItem(refreshFlagKey, 'true'); // Set refresh flag
    //         } 
    //         else {
    //             sessionStorage.removeItem(refreshFlagKey); 
    //         }
    //     };

    //     window.addEventListener('visibilitychange', handleVisibilityChange);

    //     // return () => {
    //     //     window.removeEventListener('visibilitychange', handleVisibilityChange);
    //     // };
    // }, []);

    // Fetch regularization settings and handle token expiration
    useEffect(() => {
        const sessionKey = 'session_active_emp';
    
        // Check and initialize session status
        if (!sessionStorage.getItem(sessionKey)) {
            sessionStorage.setItem(sessionKey, 'true'); // Set session as active
        }
    
        // Handle visibility changes for refresh scenarios
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                sessionStorage.setItem('refresh_flag_emp', 'true');
            } else {
                sessionStorage.removeItem('refresh_flag_emp');
            }
        };
    
        window.addEventListener('visibilitychange', handleVisibilityChange);
    
        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    const getRegularizationSettings = () => {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
            .then(response => {
                const { success, message } = response.data;
                if (success === false && message === 'session has been expired, please login again.') {
                    console.log('Token has expired, triggering idle state.');
                    setIsIdle(true); // Treat expired token as idle
                }
            })
            .catch(error => {
                console.error('Error fetching regularization settings:', error);
            });
    };

    useEffect(() => {
        if (isIdle) {
            handleLogout();
        }
    }, [isIdle]);

    useEffect(() => {
        getRegularizationSettings();
    }, []);

    return (
        <IdleTimerProvider
            timeout={idleTimeout}
            onIdle={() => setIsIdle(true)}
            onActive={resetIdleTimer}
            debounce={500} 
        >
            {null}
        </IdleTimerProvider>
    );
};

export default AutoLogout;

// import React, { useState, useEffect, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { IdleTimerProvider } from 'react-idle-timer';
// import { ConfigContext } from '../../Context/ConfigContext';
// import axios from 'axios';

// const AutoLogout = () => {
//     const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
//     const [isIdle, setIsIdle] = useState(false);
//     const navigate = useNavigate();
//     const idleTimeout = 15 * 60 * 1000; // 15 minutes
//     const sessionKey = 'session_active_emp';
//     const refreshFlagKey = 'refresh_flag_emp';

//     // Logout function
//     const handleLogout = () => {
//         console.log('Logging out due to inactivity or browser close.');
//         localStorage.removeItem('token');
//         localStorage.removeItem('company_id');
//         localStorage.removeItem('employee_id');
//         localStorage.removeItem('employee_code');
//         sessionStorage.removeItem(sessionKey); // Clear the session flag on logout
//         navigate('/Login');
//         window.location.reload();
//     };

//     // Function to reset idle timer and update last active timestamp
//     const resetIdleTimer = () => {
//         localStorage.setItem('lastActive_emp', Date.now()); // Sync across tabs
//         setIsIdle(false); // Reset idle state
//     };

//     // Sync the last active time across tabs using localStorage
//     const syncLastActive_emp = () => {
//         const storedLastActive_emp = localStorage.getItem('lastActive_emp');
//         if (storedLastActive_emp) {
//             resetIdleTimer();  // Reset idle state if activity is detected in another tab
//         }
//     };

//     useEffect(() => {
//         window.addEventListener('storage', syncLastActive_emp); // Listen for changes in other tabs
//         return () => {
//             window.removeEventListener('storage', syncLastActive_emp);
//         };
//     }, []);

//     // Check session state, but only after login
//     useEffect(() => {
//         const checkSessionState = () => {
//             const isSessionActive = sessionStorage.getItem(sessionKey);

//             // If no active session found and no refresh flag, log out
//             if (!isSessionActive && !sessionStorage.getItem(refreshFlagKey)) {
//                 handleLogout(); // Trigger logout only if session is inactive
//             }
//         };

//         const sessionFlagExists = sessionStorage.getItem(sessionKey);

//         // Only run the session check if a session exists (i.e., the user is logged in)
//         if (sessionFlagExists) {
//             checkSessionState();
//         }

//         // Handle visibility change to detect refresh
//         const handleVisibilityChange = () => {
//             if (document.visibilityState === 'hidden') {
//                 sessionStorage.setItem(refreshFlagKey, 'true'); // Set refresh flag
//             } else {
//                 sessionStorage.removeItem(refreshFlagKey); // Clear refresh flag
//             }
//         };

//         window.addEventListener('visibilitychange', handleVisibilityChange);

//         return () => {
//             window.removeEventListener('visibilitychange', handleVisibilityChange);
//         };
//     }, []);

//     // Fetch regularization settings and handle token expiration
//     const getRegularizationSettings = () => {
//         const headers = apiHeaderJSON;
//         axios
//             .get(`${apiURL}Attendance/GetRegularizationSettings`, { headers })
//             .then(response => {
//                 const { success, message } = response.data;
//                 if (success === false && message === 'This token has been expired.') {
//                     console.log('Token has expired, triggering idle state.');
//                     setIsIdle(true); // Treat expired token as idle
//                 }
//             })
//             .catch(error => {
//                 console.error('Error fetching regularization settings:', error);
//             });
//     };

//     useEffect(() => {
//         if (isIdle) {
//             handleLogout();
//         }
//     }, [isIdle]);

//     useEffect(() => {
//         getRegularizationSettings();
//     }, []);

//     // This function should be called after a successful login
//     const onLoginSuccess = () => {
//         sessionStorage.setItem(sessionKey, 'true'); // Set session active flag after login
//     };

//     return (
//         <IdleTimerProvider
//             timeout={idleTimeout}
//             onIdle={() => setIsIdle(true)}
//             onActive={resetIdleTimer}
//             debounce={500} // Prevent multiple rapid triggers
//         >
//             {/* Idle timer is handled in the background, no UI elements */}
//             {null}
//         </IdleTimerProvider>
//     );
// };

// export default AutoLogout;










